import hdrm from '../../hdrm';
import site from '../../site';
import actionTypes from '../constants/action-types';
import globals from '../../globals';

const synchronizeElement = (store) => (next) => (action) => {
  if (action.type !== actionTypes.SYNCHRONIZE_ELEMENT) {
    next(action);

    return;
  }

  const state = store.getState();
  const pageId = site.selectors.getActivePageId(state);
  const { elementId, globalsToUpdate } = action.payload;

  const newHTML = hdrm.operations.synchronizeElement(elementId);
  globals.helpers.saveGlobals(globalsToUpdate);
  store.dispatch(site.actions.setPageHTML(pageId, newHTML));

  next(action);
};

export default synchronizeElement;
